<template>
  <div class="container-fluid page">

    <!-- Stats START -->
    <div class="row my-4">

      <!-- Total Drops START -->
      <div class="col-lg-3">
        <stats-card class="bg-gradient-primary">
          <div class="row">
            <div class="col">
              <h5 class="card-title text-uppercase text-muted mb-0 text-white">Total drops</h5>
              <div class="mt-4">
                <span class="h2 font-weight-bold mb-0 text-white">{{ this.stats.totalDrops || null }}</span>
              </div>
            </div>
            <div class="col-auto">
              <div class="icon icon-shape bg-dark text-white rounded-circle shadow">
                <i class="fa fa-parachute-box"></i>
              </div>
            </div>
          </div>
          <!-- <p class="mt-3 mb-0 text-sm">
            <span class="text-white mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
            <span class="text-nowrap text-light">Since last month</span>
          </p> -->
        </stats-card>
      </div>
      <!-- // Total Drops END -->

      <!-- Total Retailer Branches START -->
      <div class="col-lg-3">
        <stats-card>
          <div class="row">
            <div class="col">
              <h5 class="card-title text-uppercase text-muted mb-0 text-dark">Total retailer branches</h5>
              <div class="mt-4">
                <span class="h2 font-weight-bold mb-0 text-dark">{{ this.stats.totalRetailerBranches || null }}</span>
              </div>
            </div>
            <div class="col-auto">
              <div class="icon icon-shape bg-primary text-white rounded-circle shadow">
                <i class="fa fa-store"></i>
              </div>
            </div>
          </div>
          <!-- <p class="mt-3 mb-0 text-sm">
            <span class="text-white mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
            <span class="text-nowrap text-light">Since last month</span>
          </p> -->
        </stats-card>
      </div>
      <!-- // Total Retailer Branches END -->

      <!-- Total Charity Branches START -->
      <div class="col-lg-3">
        <stats-card>
          <div class="row">
            <div class="col">
              <h5 class="card-title text-uppercase text-muted mb-0 text-dark">Total charity branches</h5>
              <div class="mt-4">
                <span class="h2 font-weight-bold mb-0 text-dark">{{ this.stats.totalCharityBranches || null }}</span>
              </div>
            </div>
            <div class="col-auto">
              <div class="icon icon-shape bg-primary text-white rounded-circle shadow">
                <i class="fa fa-ribbon"></i>
              </div>
            </div>
          </div>
          <!-- <p class="mt-3 mb-0 text-sm">
            <span class="text-white mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
            <span class="text-nowrap text-light">Since last month</span>
          </p> -->
        </stats-card>
      </div>
      <!-- // Total Charity Branches END -->

      <!-- Total Volunteers START -->
      <div class="col-lg-3">
        <stats-card>
          <div class="row">
            <div class="col">
              <h5 class="card-title text-uppercase text-muted mb-0 text-dark">Total volunteers</h5>
              <div class="mt-4">
                <span class="h2 font-weight-bold mb-0 text-dark">{{ this.stats.totalVolunteers || null }}</span>
              </div>
            </div>
            <div class="col-auto">
              <div class="icon icon-shape bg-primary text-white rounded-circle shadow">
                <i class="fa fa-hands-helping"></i>
              </div>
            </div>
          </div>
          <!-- <p class="mt-3 mb-0 text-sm">
            <span class="text-white mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
            <span class="text-nowrap text-light">Since last month</span>
          </p> -->
        </stats-card>
      </div>
      <!-- // Total Volunteers END -->

    </div>
    <!-- // Stats END -->


    <!-- Issue Log START -->
    <div class="row">
      <div class="col">

        

      </div>
    </div>
    <!-- // Issue Log END -->

    <!-- Drop Issues START -->
    <div class="row">
      <div class="col">

        <AdminDropsWithIssuesCard @updated="updateData()" :drops="dropsWithUnresolvedIssues" :usePagination="true"></AdminDropsWithIssuesCard>

      </div>
    </div>
    <!-- // Drop Issues END -->

    <!-- Drop Status START -->
    <div class="row flex-grow-1 mt-4">
      <div class="col">

        <DropStatusCard :drops="drops" thisLocationType="admin" :usePagination="true"></DropStatusCard>

      </div>
    </div>
    <!-- // Drop Status END -->

  </div>
</template>

<script>
  import StatsService from '../../../services/StatsService';
  import DropsService from '../../../services/DropsService';
  import DropStatusCard from "../../../components/Cards/DropStatusCard";
  import AdminDropsWithIssuesCard from "../../../components/Cards/AdminDropsWithIssuesCard";

  export default {
    name: 'admin-dashboard',

    components: {
      DropStatusCard,
      AdminDropsWithIssuesCard
    },

    data() {
      return {
        stats: {
          totalDrops: null,
          totalRetailerBranches: null,
          totalCharityBranches: null,
          totalVolunteers: null
        },
        drops: [],
        dropsWithUnresolvedIssues:[]
      };
    },

    async created() {
      this.updateData();
    },

    methods:{
      async updateData(){
        // Fetch stats
        try {
          const statsRes = await StatsService.getAdminDashboardStats();
          this.stats = statsRes.data;
        }
        catch(err) {
          console.log('Error fetching stats', {err});
          alert('Ooops, something went wrong fetching stats... The current page may not have loaded correctly.')
        }

        // Fetch drops for today
        try {
          const dropsRes = await DropsService.getAllForToday();
          this.drops = dropsRes.data;
        }
        catch(err) {
          console.log('Error fetching drops', {err});
          alert('Ooops, something went wrong fetching drops... The current page may not have loaded correctly.')
        }

        // Fetch all issues
        try {
          const issueDropsRes = await DropsService.getAllWithUnresolvedIssues();
          this.dropsWithUnresolvedIssues = issueDropsRes.data;
        }
        catch(err) {
          console.log('Error fetching drops', {err});
          alert('Ooops, something went wrong fetching drops... The current page may not have loaded correctly.')
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
    .page {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 8rem);
  }
</style>
